<template>
  <a-modal v-if="visible" title="Filters" width="600px" :visible="visible" @cancel="cancel">
    <div class="grid">
      <b class="col-4">Start Date</b>

      <a-date-picker
        class="col-8"
        format="MM/DD/YYYY"
        v-model="filters.start_date"
        valueFormat="YYYY-MM-DD"
        placeholder="Start Date"
        @change="handleStartDateChange('start_date', 'end_date')"
      />

      <b class="col-4">End Date</b>
      <a-date-picker
        class="col-8"
        format="MM/DD/YYYY"
        v-model="filters.end_date"
        valueFormat="YYYY-MM-DD"
        placeholder="End Date"
        ref="endDatePicker"
        @change="handleEndDateChange('start_date', 'end_date')"
        :open="isEndDatePickerOpen"
        :default-picker-value="getEndDateDefaultPickerValue('start_date')"
        @openChange="handleEndDateOpenChange"
      />
    </div>
    <template slot="footer">
      <div class="flex justify-content-end">
        <a-button type="danger" :disabled="isEmptyFilters" @click="reset"> Reset </a-button>
        <a-button type="primary" @click="apply"> Apply </a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import { Modal, Button, DatePicker } from 'ant-design-vue'
import { deepCopy } from '@/utils/deep-copy'
import LinkedDateFilterMixin from '@/mixins/linkedDateFilterMixin'

const filtersBaseState = Object.freeze({
  end_date: undefined,
  start_date: undefined
})

export default {
  mixins: [LinkedDateFilterMixin],
  components: {
    'a-modal': Modal,
    'a-button': Button,
    'a-date-picker': DatePicker
  },
  data() {
    return {
      filters: { ...filtersBaseState }
    }
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    currentFilters: {
      type: Object,
      required: true
    }
  },
  computed: {
    isEmptyFilters() {
      return JSON.stringify(filtersBaseState) === JSON.stringify(this.filters)
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.filters = {
            ...filtersBaseState,
            ...deepCopy(this.currentFilters)
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    reset() {
      if (this.isEmptyFilters) {
        this.cancel()
      } else {
        this.filters = deepCopy(filtersBaseState)
        this.$emit('update:currentFilters', this.filters)
      }
    },

    cancel() {
      this.$emit('update:visible', false)
    },

    apply() {
      this.$emit('update:currentFilters', this.filters)

      this.cancel()
    }
  }
}
</script>

<style scoped>
.ant-calendar-picker {
  margin: 0;
}
</style>
